import * as React from 'react';
import * as ReactDOM from 'react-dom';
import AppProvider from '@/providers';
import App from '@/App';
import { MOCK_SERVICE } from './constants/config';

(async () => {
  /**
   * @name 开发环境 mock api 请求
   * @see ./mocks/handlers.ts
   * 控制台执行  localStorage.msw_mock = 1  即可添加mock
   * 当遇到接口未mock的会走未登录之后会自动清除mock字段
   */
  if (process.env.NODE_ENV === 'development' && MOCK_SERVICE) {
    const { worker } = await import('./mocks/browser');
    await worker.start();
  }

  ReactDOM.render(
    <React.StrictMode>
      <AppProvider>
        <App />
      </AppProvider>
    </React.StrictMode>,
    document.getElementById('app')
  );
})();
